import * as React from 'react';
import { AuthProvider } from '@sdk/authentication/AuthContext';
import { CurrencyProvider } from '@sdk/common/currency/CurrencyContext';
import { TagsProvider } from '@sdk/tags/TagsContext';

import { ScheduleProvider } from '../ScheduleContext';

import ScheduleWindowedDefinition, {
  ScheduleWindowed,
  Props as ScheduleProps,
} from './ScheduleWindowed';

const ScheduleWindowedWithContext: React.FC<React.PropsWithChildren<ScheduleProps>> = (props) => {
  return (
    <AuthProvider currentUser={props.currentUser}>
      <TagsProvider tagsList={props.personaCollection.tags}>
        <CurrencyProvider>
          <ScheduleProvider
            eventCollection={props.eventCollection}
            personaCollection={props.personaCollection}
            displayMode={props.displayMode}
            currentPeriodDays={props.currentPeriodDays}>
            <ScheduleWindowed {...props} />
          </ScheduleProvider>
        </CurrencyProvider>
      </TagsProvider>
    </AuthProvider>
  );
};

export default {
  ReactComponent: ScheduleWindowedWithContext,
  bindings: { ...ScheduleWindowedDefinition.bindings },
};
